import { render, staticRenderFns } from "./Lots.vue?vue&type=template&id=45c37d0b&scoped=true"
import script from "./Lots.vue?vue&type=script&lang=js"
export * from "./Lots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c37d0b",
  null
  
)

export default component.exports